import { connect } from 'react-redux';
import { Forms } from '../..';
import { IDataStorage } from '../../../core';
import { FxTranslate } from '../../../core/translate';
import { ICardEdit } from '../../../services/operaciones/model/ICardEdit';
import { Column, DataTable } from '../../prime';
import { Secciones } from '../index.service';
import styles from './index.module.scss';
import { MonedaComboItem } from '../../../model/cobranza/MonedaComboItem';

const format = (window as any).format;

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  data?: ICardEdit | null | undefined;

  monedas?: MonedaComboItem[] | null | undefined;
  
  onUpdateFields: (updates: { field: string, value: any }[]) => void;
}

function CardSeccionProducto({ storage, t,
  data,
  monedas,
  onUpdateFields,
} : IProps) {
  return <div className={styles["card-seccion-content"]}>
    <div className={styles["card-seccion-title"]}>{t(`Menu.${Secciones.Producto}`)}</div>
    
    <div className='p-grid'>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.Input
          title={t("Seccion.Field.operacionproducto.proveedor.nombre")}
          className={styles["fix-form-component"]}
          disabled={true}
          value={data?.operacionproducto?.proveedor?.nombre ?? data?.operacionproducto?.proveedor_nombre} 
          //onChange={(v,e) => onUpdateField('operacionproducto.proveedor.nombre', v)}
        />
      </div>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.Input
          title={t("Seccion.Field.operacionproducto.producto.nombre")}
          className={styles["fix-form-component"]}
          disabled={true}
          value={data?.operacionproducto?.producto?.nombre ?? data?.operacionproducto?.producto_nombre}
          //onChange={(v,e) => onUpdateField('operacionproducto.producto.nombre', v)}
        />
      </div>

      <div className='p-col-12'>
        <div className="datatable-responsive-demo">
          <DataTable 
            value={(data?.operacionupgrades ?? []).sort((a,b) => (a.paxindex ?? a.pasajeroindex ?? 0) > (b.paxindex ?? b.pasajeroindex ?? 0) ? 1 : -1)}
            className="p-datatable-responsive-demo"
          >
            <Column 
              field='pasajero' 
              header={t("Seccion.Field.operacionupgrades.pasajero")}
              body={row => {
                if (!window.app_usems) {
                  const pasajero = (data?.operacionpasajeros??[])[row.pasajeroindex]?.pasajero;
                  return <>{pasajero?.nombre} {pasajero?.apellido}</>;
                } else {
                  const pasajero = (data?.operacionpasajeros??[]).find(p => p.paxindex === row.paxindex);
                  return <>{pasajero?.nombre} {pasajero?.apellido}</>;
                }
              }}
            />
            <Column 
              //field='upgrade.nombre' 
              header={t("Seccion.Field.operacionupgrades.upgrade")} 
              body={row => <>{row.upgrade?.nombre ?? t(row.upgrade_nombre)}</>}
            />
            {!window.app_usems && <Column field='precio' header={t("Seccion.Field.operacionupgrades.precio")} body={row => <>{monedas?.find(p => p.id === data?.operacionpago?.idmoneda)?.codigo} {format(row.precio, `$$`)}</>}/>}
            {!!window.app_usems && <Column field='precio' header={t("Seccion.Field.operacionupgrades.precio")} body={row => <>{monedas?.find(p => p.id === data?.operacionpago?.idmoneda)?.codigo} {format(row.preciousd * (data?.operacionproducto?.monedacotizacion??1), `$$`)}</>}/>}
            <Column field='precioUSD' header={t("Seccion.Field.operacionupgrades.precioUSD")} body={row => <>USD {format(row.precioUSD ?? row.preciousd, `$$`)}</>} />
          </DataTable>
        </div>
      </div>
    </div>
  </div>
}
export default connect((s:any) => ({ storage:s.main }))(CardSeccionProducto);
